export const discountMock = {
  type: 'PERCENT',
  value: 10,
};
